/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

export default class Timeline extends Component {
    render() {
        return (
            <div>
                <section className="colorlib-experience" data-section="timeline">
                    <div className="colorlib-narrow-content">
                        <div className="row">
                            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                                <span className="heading-meta">highlights</span>
                                <h2 className="colorlib-heading animate-box">Timeline</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="timeline-centered">
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-3">
                                                <i className="icon-pen2" />
                                            </div>
                                            <div className="timeline-label">
                                                <h2> <a href="#">Internship at Broadbased Communications</a> <span>2018</span></h2>
                                                <p> I recently completed my intership with Broadbased communications  as a Network - intern engineer. My major job was to Configure and define parameters for installation or testing of local area network (LAN),
                                                 wide area network (WAN), hubs, routers, switches, controllers, multiplexers, or related networking equipment. </p>
                                                <p> Install network software, including security or firewall software. Install or repair network cables, including fiber optic cables.Maintain and administer computer networks and related computing environments
                                                including computer hardware, systems software, applications software, and all configurations. </p>


                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-4">
                                                <i className="icon-pen2" />
                                            </div>
                                            <div className="timeline-label">
                                                <h2> <a href="#">Programming languague </a> <span> 2019 </span> </h2>
                                                <p>I am learning more about more programming language to widen my knowledge about computer programming, i recently completeed a course on fullstack where i learnt about Html, Css, ES6 , React Js (which i used in building this portfolio), still in process of learning ApI, Node Js, Express js and many more.</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-5">
                                                <i className="icon-pen2" />
                                            </div>
                                            <div className="timeline-label">
                                                <h2> <a href="#">Diploma in Computer Engineering</a> <span>2013-2014</span></h2>
                                                <p> I developed interest in computer engineering and it helped me to improve my understanding of any problem and also my mathematical skills to actually solve the problems.</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-none">
                                            </div>
                                        </div>
                                    </article>
                                    {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-5">
                                                <i className="icon-pen2" />
                                            </div>
                                            <div className="timeline-label">
                                               <h2> <a href="#">Primary and Higher Education</a> <span>2003-2015</span></h2>
                                                <p>I have completed my higher secondary education. During my time at school, I have developed interest in solving complex problems of the fundamental physics and futher mathematical which helped me to improve my understanding of any problem and also my mathematical skills to actually solve the problems.</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-none">
                                            </div>
                                        </div>
                                    </article>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
